import React, { useState } from "react";
import "./App.css";
import Navbar from "./components/Navbar/Nav";
import AllRoutes from "./Routes/Route";
import Footer from "./components/Footer/Footer";
import Chatbot from "./components/chatapp/ChatComponent";
import { chatbot } from "./assets/icons";
import { CursorProvider } from "./shared/config/cursorProvider";

const App = () => {

  const [chat, setChat] = useState(false);

  const handleChatBotClick = () => {
    setChat((chat) => !chat);
  };

  return (
    <CursorProvider>
      <div className="main-container">
        <Navbar />
        <AllRoutes />
        <div className="chatbot-img" onClick={handleChatBotClick}>
          <img src={chatbot} alt="" />
        </div>
        {chat && (
          <div className="chat-app">
            <Chatbot setChat={setChat} />
          </div>
        )}
        <Footer />
      </div>
    </CursorProvider>
  );
};

export default App;
